<script>
export default {
    name: 'Badge',
    props: {
        type: {
            type: String,
            default: 'primary',
        },
        icon: null,
        iconType: null,
        pill: Boolean,
        disabled: Boolean,
        size: null,
    },
    computed: {
        closable() {
            return 'close' in this.$listeners
        },
        btnSize() {
            switch (this.size) {
                case 'xl':
                    return 'btn-lg'
                case 'lg':
                    return 'btn-md'
                default:
                    return ''
            }
        },
    },
    methods: {
        close() {
            this.$emit('close')
        },
    },
}
</script>

<template lang="pug">
span.badge(:class="[`badge-${type}`,size ?  `badge-${size}` : '', {'badge-pill': pill}]")
    icon.icon.mr-4(v-if="icon" :icon="icon" :class="iconType ? `text-${iconType}` : null")
    span.badge-text(:class="size ? `font-size-${size}` : 'font-size-xs'")
        slot
    button.btn-reset.pr-0(v-if="closable" :class="[btnSize, type === 'transparent' ? 'pl-2': 'pl-4']" :disabled="disabled" @click="close")
        icon(:icon="`${type === 'transparent' ? 'fa-solid' : 'fa-regular'} fa-times-circle`")
</template>
